module.exports = __webpack_public_path__ + "static/GT-America-Standard-Bold.cac42895.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GT-America-Standard-Bold.woff
// module id = 449
// module chunks = 168707334958949